type LoadingOperation<T> = () => Promise<T>;
type QueueItem<T> = {
  operation: LoadingOperation<T>;
  resolve: (value: T) => void;
  reject: (error: any) => void;
};

class StateLoadingQueueManager {
  private queue: QueueItem<any>[] = [];
  private isProcessing = false;
  private static instance: StateLoadingQueueManager;

  private constructor() {}

  static getInstance(): StateLoadingQueueManager {
    if (!StateLoadingQueueManager.instance) {
      StateLoadingQueueManager.instance = new StateLoadingQueueManager();
    }
    return StateLoadingQueueManager.instance;
  }

  async enqueue<T>(operation: LoadingOperation<T>): Promise<T> {
    return new Promise<T>((resolve, reject) => {
      this.queue.push({ operation, resolve, reject });
      if (!this.isProcessing) {
        this.processQueue();
      }
    });
  }

  private async processQueue() {
    if (this.isProcessing || this.queue.length === 0) return;

    this.isProcessing = true;
    const { operation, resolve, reject } = this.queue[0];

    try {
      console.log('Processing state loading operation');
      const result = await operation();
      resolve(result);
    } catch (error) {
      console.error('Error in state loading operation:', error);
      reject(error);
    } finally {
      this.queue.shift();
      this.isProcessing = false;
      if (this.queue.length > 0) {
        this.processQueue();
      }
    }
  }

  clearQueue() {
    this.queue = [];
    this.isProcessing = false;
  }
}

export const stateLoadingQueue = StateLoadingQueueManager.getInstance();